import * as z from "zod";
import { OC } from "../../utils";
import { ClientDiscountCode } from "../discount-code/schema";
import { ClientTrip } from "../trip/schema";
import { ClientReservation } from "./schema";

export const reservationContract = OC.router({
  get: OC.input(ClientReservation.Get).output(
    ClientReservation.Reservation.extend({
      trip: ClientTrip.Trip.omit({
        locations: true,
        groupPricing: true,
        agencyPublicKey: true,
      }),
      payments: z.array(ClientReservation.Payment),
      discount: ClientDiscountCode.DiscountCode.nullable(),
    }),
  ),
  getAll: OC.input(ClientReservation.GetAll).output(
    z.array(
      ClientReservation.Reservation.extend({
        trip: ClientTrip.Trip.omit({
          locations: true,
          groupPricing: true,
          agencyPublicKey: true,
        }),
      }),
    ),
  ),
  create: OC.input(ClientReservation.Create).output(z.object({ id: z.string() })),
  getPaymentUrl: OC.input(ClientReservation.GetPaymentUrl).output(z.object({ amount: z.number(), url: z.string() })),
  cancel: OC.input(ClientReservation.Get).output(z.object({ id: z.string() })),
});
